import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { EAppointmentType } from "@constants";

interface IParams {
    appointmentType?: EAppointmentType;
}

export const InstallationDateChange = (props: IParams) => {
    const { appointmentType } = props;
    const { t } = useTranslation("installation");

    return (
        <section>
            <Grid container spacing={2}>
                <Grid item>
                    <Typography color="secondary" component="p" gutterBottom variant="normal">
                        {appointmentType === EAppointmentType.NO_INSTALL
                            ? t("noInstallDateChange")
                            : t("fullInstallDateChange")}
                    </Typography>
                </Grid>
            </Grid>
        </section>
    );
};
